import { render, staticRenderFns } from "./BlocoInformacaoCertificacao.vue?vue&type=template&id=b2129d6e&scoped=true"
import script from "./BlocoInformacaoCertificacao.vue?vue&type=script&lang=js"
export * from "./BlocoInformacaoCertificacao.vue?vue&type=script&lang=js"
import style0 from "./BlocoInformacaoCertificacao.vue?vue&type=style&index=0&id=b2129d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2129d6e",
  null
  
)

export default component.exports